<script lang="ts">
    import ClickAction from '~/components/jet/action/ClickAction.svelte';
    import TrackListFooterLockup from '@amp/web-app-components/src/components/TrackList/TrackListFooterLockup.svelte';
    import type { Section } from '@jet-app/music-classical/models/section/Section';
    import type { TrackListFooter } from '~/jet/models';

    export let section: Section<TrackListFooter>;

    $: item = section.items?.[0];
    $: isAlbum = item.screenType === 'album';
    $: isPlaylist = item.screenType === 'playlist';
    $: isRecording = item.screenType === 'recording';
</script>

<TrackListFooterLockup
    {item}
    {isAlbum}
    {isPlaylist}
    {isRecording}
    clickComponent={ClickAction}
/>
